module.exports = __webpack_public_path__ + "static/media/fullPhoto.adb08710.jpg";